import React from 'react';
import { Link } from 'react-router-dom';

const BrandLogo = ({ 
  className = "", 
  style = {}, 
  height = "auto",
  maxHeight = "1.5rem",
  linkTo = "/",
  showLink = true 
}) => {
  const logoStyle = {
    height: height,
    maxHeight: maxHeight,
    width: 'auto',
    objectFit: 'contain',
    ...style
  };

  const logoElement = (
    <img
      src="/images/RecapVid-Logo.png"
      alt="RecapVid"
      className={className}
      style={logoStyle}
    />
  );

  if (showLink) {
    return (
      <Link to={linkTo} className="navbar-brand d-flex align-items-center">
        {logoElement}
      </Link>
    );
  }

  return logoElement;
};

export default BrandLogo;

